module.exports = __webpack_public_path__ + "assets/img/smartTV-module4-10.5c51689f.jpg";